<template>
  <div class="container">
    <!-- Modal -->
    <div
      :class="[(this.$store.state.modal.alert.show === true) ? 'in show' : '', 'modal fade alertGlobal']"
      id="alertGlobal"
      role="dialog">

      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div :class="[(this.$store.state.modal.alert.status) ? 'sucesso' : 'falhou', 'modal-header']">

            <button type="button" class="close" data-dismiss="modal" v-on:click="fecharModal()">&times;</button>

            <h4 class="modal-title alert-title" v-if="this.$store.state.modal.alert.status"> Sucesso! <span> :-) </span> </h4>
            <h4 class="modal-title alert-title" v-else> Algo deu errado! <span> :-( </span></h4>


          </div>
            <div class="modal-body alert-body" v-html="this.$store.state.modal.alert.msg"></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal" v-on:click="fecharModal()">Fechar</button>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
export default {
  methods: {
    fecharModal: function () {
      this.$store.commit('setAlert', {msg: '', status: true, show: false})
    }
  }
}
</script>
<style scoped>
  .alertGlobal {
    transition: 1s;
    z-index: 999999;
  }
  .alert-title {
    text-align: center;
    font-size: 1.7em;
  }
  .alert-body {
    font-size: 1.2em;
    padding: 2em;
    text-align: center;
  }
  .sucesso {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
  .falhou {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
  .alert-title span {
    transform: rotate(90deg);
    display: inline-block;
    font-size: 1.1em;
    margin-left: .5em;
    font-weight: 600;
  }
  .modal {
    z-index: 100000;
  }
</style>



// WEBPACK FOOTER //
// AlertGlobal.vue?a3fe9516